import {
  withTranslation,
} from 'react-i18next';

import RegattaSponsorsSectionView from './RegattaSponsorsSectionView';

const TranslatedComponent = withTranslation()(RegattaSponsorsSectionView);

const Component = TranslatedComponent;

export default Component;
